export enum FTPConversionSource {
  SideBySide = 'SideBySide',
  UntrackedSource = 'UntrackedSource',
}

export const FTPConversionSourceURLQueryKey = 'conversionSource';
